import PropTypes from 'prop-types';

import FormStepModal from '#client/components/FormStepModal';

import Settings from './components/LinkAccountOptions';

export default function CardModal({ handleClose }) {
  return (
    <FormStepModal
      disableBack
      handleClose={handleClose}
      title="Cards"
    >
      <Settings handleClose={handleClose} />
    </FormStepModal>
  );
}

CardModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
